new Swiper('.text-gallery-slider', {
     breakpoints: {
        0: {
          slidesPerView: 1.4,
          spaceBetween: 20,
        },
        580: {
          slidesPerView: 2.1,
          spaceBetween: 20,
        },
        767: {
          slidesPerView: 2.1,
          spaceBetween: 20,
        },
     },
});
